"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var actions = __importStar(require("./userActions"));
var articlesActions = __importStar(require("../yourtrybe/articles/articlesActions"));
var Mixpanel_1 = require("../Mixpanel");
var defaultState = {
    userIsLogged: false,
    token: null,
    loginning: false,
    authError: false,
    userInfo: {},
    gettingUserData: false,
    forgotPasswordMode: false,
    forgotPasswordResponse: null,
    resetPasswordLoading: false,
    resetPasswordResponse: null,
    email: ''
};
function reducer(state, action) {
    if (state === void 0) { state = defaultState; }
    var payload = action.payload;
    switch (action.type) {
        case actions.postLogin.TRIGGER: {
            return __assign(__assign({}, state), { userIsLogged: false, loginning: true });
        }
        case actions.postLogin.SUCCESS: {
            var newState = __assign(__assign({}, state), { authError: false, userIsLogged: true });
            return newState;
        }
        case actions.postLogin.FAILURE: {
            return __assign(__assign({}, state), { userIsLogged: false, loginning: false, authError: payload });
        }
        case actions.getUserData.TRIGGER: {
            return __assign(__assign({}, state), { loginning: true, gettingUserData: true });
        }
        case actions.getUserData.SUCCESS: {
            return __assign(__assign({}, state), { userInfo: payload, loginning: false, userIsLogged: true, gettingUserData: false });
        }
        case actions.getUserData.FAILURE: {
            return __assign(__assign({}, state), { userIsLogged: false, loginning: false, gettingUserData: false });
        }
        case actions.forceUserLogin.TRIGGER: {
            return __assign(__assign({}, state), { userIsLogged: true, userInfo: payload });
        }
        case actions.setScroll.TRIGGER: {
            return __assign(__assign({}, state), { scrollPosition: true });
        }
        case actions.userSignOut.TRIGGER: {
            return __assign(__assign({}, state), { userIsLogged: false, userInfo: {}, token: null });
        }
        case articlesActions.addFavoriteCategory.SUCCESS: {
            var category = payload.category;
            var categories = state.userInfo.favoriteCategories
                ? __spreadArray([], state.userInfo.favoriteCategories, true) : [];
            categories.push(category);
            var user = __assign({}, state.userInfo);
            user.details.favoriteCategories = categories;
            return __assign(__assign({}, state), { userInfo: user });
        }
        case actions.forgotPasswordClick.TRIGGER: {
            return __assign(__assign({}, state), { forgotPasswordMode: true, email: '' });
        }
        case actions.returnToLoginMode.TRIGGER: {
            return __assign(__assign({}, state), { forgotPasswordMode: false, forgotPasswordResponse: false, email: '' });
        }
        case actions.forgotPasswordRequest.TRIGGER: {
            return __assign(__assign({}, state), { resetPasswordLoading: true, email: payload.email });
        }
        case actions.forgotPasswordRequest.SUCCESS: {
            return __assign(__assign({}, state), { resetPasswordLoading: false, forgotPasswordResponse: payload, authError: false });
        }
        case actions.forgotPasswordRequest.FAILURE: {
            return __assign(__assign({}, state), { resetPasswordLoading: false, forgotPasswordResponse: payload, authError: payload });
        }
        case actions.sendNewPassword.TRIGGER: {
            return __assign(__assign({}, state), { resetPasswordLoading: true });
        }
        case actions.sendNewPassword.SUCCESS: {
            return __assign(__assign({}, state), { resetPasswordLoading: false, resetPasswordResponse: payload, forgotPasswordResponse: null, authError: false, email: '' });
        }
        case actions.sendNewPassword.FAILURE: {
            return __assign(__assign({}, state), { resetPasswordLoading: false, resetPasswordResponse: payload, authError: payload, email: '' });
        }
        default:
            return state;
    }
}
exports.default = reducer;
